import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import {atomToastAutoCloseTimes} from '@s-ui/react-atom-toast'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'

import SearchSaveNotification, {SEARCH_SAVE_NOTIFICATION_TYPES} from './search-save-notification.js'

const SearchSaveMaxLimitReachedNotification = ({show, onClose = () => {}, portalContainer, className}) => {
  const {i18n, domain} = useContext(Context)
  const {push} = useRouter()

  const config = domain.get('config')
  const {USER_SAVED_SEARCHES_PATH_PATTERN} = config.get('page')
  const {
    SEARCH_SAVE: {MAX_ALERTS_LIMIT_REACHED}
  } = config.get('COMMON')

  return (
    <SearchSaveNotification
      className={className}
      portalContainer={portalContainer}
      show={show}
      onClose={onClose}
      autoCloseTime={atomToastAutoCloseTimes.long}
      type={SEARCH_SAVE_NOTIFICATION_TYPES.WARNING}
      action={
        <AtomButton design={atomButtonDesigns.LINK} negative onClick={() => push(USER_SAVED_SEARCHES_PATH_PATTERN)}>
          {i18n.t('ALERT_NOTIFICATION_SHOW_RESULTS_CTA')}
        </AtomButton>
      }
    >
      {i18n.t('ALERT_MAX_LIMIT_REACHED_NOTIFICATION_MESSAGE', {maxAlerts: MAX_ALERTS_LIMIT_REACHED})}
    </SearchSaveNotification>
  )
}

SearchSaveMaxLimitReachedNotification.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string
}

export default SearchSaveMaxLimitReachedNotification
